import React from 'react';
import Form from "./Form";

const Pl = () => {
    return (
        <div className="info-pages-main-content">
            <div className="info-page-inner-content price-list">
                <h4>Instrukcje usuwania danych:</h4>
                <p>
                    Jeśli chcesz usunąć swoje dane z
                    <a href="https://ifurn.pro/" className="" target={'_blank'}> iFurn.pro</a>,
                    Podaj swoje dane kontaktowe w celu usunięcia i powód.
                </p>
            </div>
            <Form/>

        </div>
    );
};

export default Pl;